package com.parmartechnologies.core.app

enum class AppType {
    CUSTOMER, E_COMMERCE, BUSINESS, FRIENDLY
}

enum class PlatformType {
    iOS, Android, Web, Windows, linux, Mac, Mobile, Desktop
}
